import { render, staticRenderFns } from "./OnlinePlayers.vue?vue&type=template&id=d71642e2&"
import script from "./OnlinePlayers.vue?vue&type=script&lang=js&"
export * from "./OnlinePlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports